import { REACT_APP_VMS_BASE_URL } from "../utils/urls";

const fetchVisitsIn = async (site_id: any) => {
  if (site_id === undefined) {
    return [];
  }
  const result = await fetch(`${REACT_APP_VMS_BASE_URL}/visits/${site_id}/in`);
  const visits = await result.json();
  return visits;
};

export default fetchVisitsIn;
